/* Touch has no hover: hold to inspect the label, tap normally to activate the header action. */
(function () {
    document.querySelectorAll('.fw-tooltip-control').forEach(function (control) {
        const button = control.querySelector('.fw-button');
        let timer;
        let held = false;
        let start;
        function cancel() { clearTimeout(timer); timer = undefined; }
        function dismiss() {
            cancel();
            control.classList.remove('fw-tooltip-open');
            control.classList.add('fw-tooltip-dismissed');
        }
        button.addEventListener('pointerdown', function (event) {
            cancel();
            held = false;
            control.classList.remove('fw-tooltip-dismissed');
            if (event.pointerType !== 'touch' || !event.isPrimary) return;
            start = {x: event.clientX, y: event.clientY};
            timer = setTimeout(function () {
                held = true;
                control.classList.add('fw-tooltip-open');
            }, 450);
        });
        button.addEventListener('pointermove', function (event) {
            if (timer && start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 10) dismiss();
        });
        button.addEventListener('pointerup', cancel);
        button.addEventListener('pointercancel', function () { dismiss(); held = false; });
        button.addEventListener('pointerleave', cancel);
        button.addEventListener('contextmenu', function (event) { if (held) event.preventDefault(); });
        button.addEventListener('click', function (event) {
            if (held) {
                event.preventDefault();
                event.stopImmediatePropagation();
                held = false;
            } else dismiss();
        }, true);
        control.addEventListener('pointerenter', function () { control.classList.remove('fw-tooltip-dismissed'); });
        button.addEventListener('focus', function () { control.classList.remove('fw-tooltip-dismissed'); });
        button.addEventListener('blur', dismiss);
        document.addEventListener('pointerdown', function (event) { if (!control.contains(event.target)) dismiss(); });
        document.addEventListener('keydown', function (event) { if (event.key === 'Escape') dismiss(); });
    });
})();
